package org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_price

import androidx.compose.runtime.key
import org.hs_soft.runmynesto.domain.model.general.TitleEnum
import org.hs_soft.runmynesto.domain.model.home.product.ProductInfoHeaderEnum
import org.hs_soft.runmynesto.domain.util.helper.LanguageManager

enum class PriceTableHeaderEnum(
    val key:String
) : TitleEnum
{
    TYPE(
        key="typeName"
    ),
    START_DATE(
        key="fromDate"
    ),
    END_DATE(
        key="toDate"
    ),
    NAME(
        key ="name"
    );


    override val title: String
        get() = LanguageManager.getCurrentStrings().let { strings ->
            when (this) {
                TYPE -> strings.type
                START_DATE -> strings.startDate
                END_DATE ->strings.endDate
                 NAME -> strings.name
            }
        }


}